var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67.6,
    height: 67.7,
    viewBox: "0 0 67.6 67.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 9.91,
    y1: 57.74,
    x2: 57.69,
    y2: 9.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f48a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d163ab"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8,67.7A33.85,33.85,0,1,0,0,33.8,33.82,33.82,0,0,0,33.8,67.7Z",
    fillRule: "evenodd",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.72,27.55v12.6a3.78,3.78,0,0,0,3.78,3.78H40.1a3.78,3.78,0,0,0,3.78-3.78V27.55a3.78,3.78,0,0,0-3.78-3.78H27.5A3.78,3.78,0,0,0,23.72,27.55Zm16.66,0v12.6a.29.29,0,0,1-.28.28H27.5a.29.29,0,0,1-.28-.28V27.55a.29.29,0,0,1,.28-.28H40.1A.29.29,0,0,1,40.38,27.55Zm-24.11.95V22.09A5.78,5.78,0,0,1,22,16.32h6.41a1.75,1.75,0,0,1,0,3.5H22a2.27,2.27,0,0,0-2.27,2.27V28.5a1.75,1.75,0,0,1-3.5,0Zm35.06-6.41V28.5a1.75,1.75,0,0,1-3.5,0V22.09a2.27,2.27,0,0,0-2.27-2.27H39.15a1.75,1.75,0,0,1,0-3.5h6.41A5.78,5.78,0,0,1,51.33,22.09ZM30.2,49.63a1.76,1.76,0,0,1-1.75,1.75H22a5.78,5.78,0,0,1-5.77-5.77V39.2a1.75,1.75,0,0,1,3.5,0v6.41A2.27,2.27,0,0,0,22,47.88h6.41A1.75,1.75,0,0,1,30.2,49.63ZM51.33,39.2v6.41a5.78,5.78,0,0,1-5.77,5.77H39.15a1.75,1.75,0,0,1,0-3.5h6.41a2.27,2.27,0,0,0,2.27-2.27V39.2a1.75,1.75,0,0,1,3.5,0Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.206b19c4e0ffed4ab88865ab40a1885f.svg";
export { ForwardRef as ReactComponent };